import MobileHeader, { MobileHeaderProps } from 'UIKit/MobileHeader'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { useScrollPositionInfoById } from 'hooks/useScrollPositionInfoById'

const PageHeader = ({ title, children, ...props }: MobileHeaderProps) => {
  const { isMobile } = useMatchBreakpoints()
  const isScrolled = useScrollPositionInfoById()

  return (
    isMobile && (
      <MobileHeader title={title} displayBorder={isScrolled} {...props}>
        {children}
      </MobileHeader>
    )
  )
}

export default PageHeader
